import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import axios from '../../axios';

const EnrollmentForm = ({ show, onHide, currentAcademicYear, enrollment, onSave }) => {
  const [formData, setFormData] = useState({
    academicYear: currentAcademicYear,
    examNumber: '',
    studentId: '',
    barcode: '',
    enrollmentReceiptNumber: '',
    class: '',
    name: '',
    citizenId: '',
    birthDate: '',
    gender: 'Nam',
    majorName: '',
    majorCode: '',
    enrollmentDate: '',
    admissionMethod: '',
    province: '',
    phoneNumber: '',
    notes: ''
  });

  const [error, setError] = useState('');

  useEffect(() => {
    if (enrollment) {
      setFormData({
        academicYear: enrollment.academicYear,
        examNumber: enrollment.examNumber,
        studentId: enrollment.studentId,
        barcode: enrollment.barcode,
        enrollmentReceiptNumber: enrollment.enrollmentReceiptNumber,
        class: enrollment.class,
        name: enrollment.name,
        citizenId: enrollment.citizenId,
        birthDate: new Date(enrollment.birthDate).toISOString().split('T')[0],
        gender: enrollment.gender,
        majorName: enrollment.majorName,
        majorCode: enrollment.majorCode,
        enrollmentDate: new Date(enrollment.enrollmentDate).toISOString().split('T')[0],
        admissionMethod: enrollment.admissionMethod,
        province: enrollment.province,
        phoneNumber: enrollment.phoneNumber,
        notes: enrollment.notes
      });
    }
  }, [enrollment]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (enrollment) {
        await axios.put(`/enrollments/${enrollment._id}`, formData);
      } else {
        await axios.post('/enrollments', formData);
      }
      onSave();
      onHide();
    } catch (err) {
      setError('Failed to save enrollment data');
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{enrollment ? 'Edit Enrollment' : 'Add Enrollment'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Exam Number</Form.Label>
            <Form.Control
              type="text"
              name="examNumber"
              value={formData.examNumber}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Student ID</Form.Label>
            <Form.Control
              type="text"
              name="studentId"
              value={formData.studentId}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Barcode</Form.Label>
            <Form.Control
              type="text"
              name="barcode"
              value={formData.barcode}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Receipt Number</Form.Label>
            <Form.Control
              type="text"
              name="enrollmentReceiptNumber"
              value={formData.enrollmentReceiptNumber}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Citizen ID</Form.Label>
            <Form.Control
              type="text"
              name="citizenId"
              value={formData.citizenId}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Birth Date</Form.Label>
            <Form.Control
              type="date"
              name="birthDate"
              value={formData.birthDate}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Gender</Form.Label>
            <Form.Control
              as="select"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="Nam">Nam</option>
              <option value="Nữ">Nữ</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Major Name</Form.Label>
            <Form.Control
              type="text"
              name="majorName"
              value={formData.majorName}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Major Code</Form.Label>
            <Form.Control
              type="text"
              name="majorCode"
              value={formData.majorCode}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Enrollment Date</Form.Label>
            <Form.Control
              type="date"
              name="enrollmentDate"
              value={formData.enrollmentDate}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Admission Method</Form.Label>
            <Form.Control
              type="text"
              name="admissionMethod"
              value={formData.admissionMethod}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Province</Form.Label>
            <Form.Control
              type="text"
              name="province"
              value={formData.province}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Tạo mới">Tạo mới</option>
              <option value="Đã xác nhận nhập học">Đã xác nhận nhập học</option>
              <option value="Đã nộp tiền">Đã nộp tiền</option>
              <option value="Đã chia lớp">Đã chia lớp</option>
              <option value="Đã nộp hồ sơ">Đã nộp hồ sơ</option>
            </Form.Control>
          </Form.Group>
          <Button variant="primary" type="submit">
            {enrollment ? 'Update Enrollment' : 'Add Enrollment'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EnrollmentForm;
